import { Spacings, Fonts, mediaQuery } from '@styles/index';
import Button from '@base/Button/Button';
import styled from '@emotion/styled';
import Paper from '@base/Paper/Paper';
import Image from '@base/Image';
import { getBulletPoints } from '@cont/SeeAll/TestSeriesListing/DailyScholarshipTest/Unattempted';

const MobileContainer = styled(Paper)`
  display: none;
  ${mediaQuery.uptoMobile} {
    display: block;
    margin: 0 ${Spacings.SPACING_4B} ${Spacings.SPACING_4B};
    top: -32px;
    width: calc(100% - 32px);
    position: relative;
    padding: ${Spacings.SPACING_6B} ${Spacings.SPACING_4B};
  }
`;

const HeaderTitle = styled.div`
  font-size: ${Fonts.H4};
  font-weight: ${Fonts.HEAVY};
  line-height: 26px;
  color: var(--color-text-primary);
  margin: ${Spacings.SPACING_4B} 0 ${Spacings.SPACING_2B};
`;

const HeaderLabel = styled.div`
  font-size: ${Fonts.P1};
  line-height: 20px;
  color: var(--color-text-secondary);
  margin-bottom: ${Spacings.SPACING_4B};
`;

const Point = styled.div`
  margin-bottom: ${Spacings.SPACING_2B};
  display: flex;
  align-items: center;
`;

const Text = styled.div`
  font-size: ${Fonts.H7};
  line-height: ${Spacings.SPACING_4B};
  color: var(--color-text-primary);
  margin-left: ${Spacings.SPACING_3B};
`;

const MobileStyledBtn = styled(Button)`
  width: 90px;
  height: 40px;
  min-height: 40px;
  margin-top: ${Spacings.SPACING_4B};
  border-radius: 8px;
  font-size: ${Fonts.H6};
  font-weight: 700;
`;

const DSTMobile = ({ data, takeTest }) => {
  const bulletPoints = getBulletPoints(data.data[0]);
  const { header, subHeader } = data.extraBlockInfo || {};

  return (
    <MobileContainer className="container">
      <Image
        src="/dst/trophy-mobile.svg"
        height={51}
        width={76}
        alt="dst-trophy"
      />
      <HeaderTitle>{header}</HeaderTitle>
      <HeaderLabel>{subHeader}</HeaderLabel>
      {bulletPoints.map(({ text }) => {
        return (
          <Point key={text}>
            <Image
              src="/dst/tick.svg"
              height={18}
              width={18}
              alt="dst-points"
            />
            <Text>{text}</Text>
          </Point>
        );
      })}
      <MobileStyledBtn
        // @ts-ignore
        label="Take test"
        variant="hollow"
        color="green"
        onClick={takeTest}
      />
    </MobileContainer>
  );
};

export default DSTMobile;
